<script>
import { mapActions } from 'vuex'

export default {
  methods: {
    ...mapActions([
      'setUserAction',
      'setLoginAction',
      'setUserInfoAction'
    ]),
    setUserData (response, token) {
      let user = response ? response.data.user || response.data.data : null
      token = token || (response ? response.data.auth : null)
      this.setUserAction(user)
      this.setLoginAction(!!response)
      this.setUserInfo(token)
      return user
    },
    setUserInfo (token) {
      if (token) {
        // let expiry = new Date(token.expired_at) - new Date()
        let info = {
          access_token: token.access_token
        }
        this.setUserInfoAction(info)
        this.$ls.set('userInfo', info)
      } else {
        this.setUserInfoAction(null)
        this.$ls.remove('userInfo')
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/mixins/loginData.vue